<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<!--<div
  class="view-with-static-right-sidebar ps"
  [ngClass]="{ 'sidebar-opened': activitiesService.isOpened }"
  [perfectScrollbar]
>-->

<div class="campaign-view-wrapper relative">
  <div class="top">
    <div class="preview-header d-flex justify-content-between">
      <div class="preview-title-wrapper">
        <span class="additional-info">
          <span class="sub-title">{{ 'CAMPAIGN.CAMPAIGN_VIEW.CREATED_AT' | translate }}</span>
          <span class="value"
            >{{ campaign?.created_at.getDate() }} {{ campaign?.created_at.getHours() }}:{{
              campaign?.created_at.getMinutes()
            }}</span
          >

          <span class="sub-title">{{ 'CAMPAIGN.CAMPAIGN_VIEW.TEMPLATE' | translate }}</span>
          <span class="value">{{ campaign?.template?.name }}</span>

          <span class="sub-title ml-1">{{ 'CAMPAIGN.CAMPAIGN_VIEW.EVENT' | translate }}</span>
          <span class="value">{{ campaign?.event.name }}</span>
        </span>
      </div>
      <div class="preview-btns-wrapper">
        <a
          [routerLink]="['/campaign/create']"
          [queryParams]="{ resend: campaign?.id }"
          target="_blank"
          class="btn btn-info"
        >
          {{ 'CAMPAIGN.BUTTONS.RESEND' | translate }}
        </a>
      </div>
    </div>
  </div>

  <div class="title2">
    {{ 'CAMPAIGN.CAMPAIGN_VIEW.SALES' | translate }}
  </div>

  <kendo-grid [style.height]="'100%'" [columnMenu]="false" [pageable]="false" [data]="campaign.sales">
    <kendo-grid-column
      [width]="70"
      class="text-center"
      headerClass="text-center"
      title="{{ 'CAMPAIGN.CAMPAIGN_LIST.NUMBER' | translate }}"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ rowIndex + 1 }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      class="text-center"
      headerClass="text-center"
      field="sale.id"
      title="{{ 'CAMPAIGN.CAMPAIGN_LIST.ID' | translate }}"
      filter="numeric"
      [width]="120"
    ></kendo-grid-column>

    <kendo-grid-column
      class="text-center"
      headerClass="text-center"
      field="sale.client.name"
      title="{{ 'CAMPAIGN.CAMPAIGN_LIST.CLIENT' | translate }}"
      filter="text"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-client-box [client]="dataItem.sale.client" [flag]="true"></app-client-box>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      class="text-center"
      headerClass="text-center"
      field="sale.event.formattedName"
      title="{{ 'CAMPAIGN.CAMPAIGN_LIST.EVENT' | translate }}"
      filter="text"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <a [routerLink]="['/events/view']" [queryParams]="{ id: dataItem?.sale?.event?.id }" target="_blank">
          {{ dataItem?.sale?.event?.formattedName }}
        </a>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      class="text-center"
      headerClass="text-center"
      field="sale.status.value"
      title="{{ 'CAMPAIGN.CAMPAIGN_LIST.STATUS' | translate }}"
      filter="text"
      [width]="120"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-type-badge [type]="dataItem.sale.status"></app-type-badge>
        <div class="text-truncate" [ngbTooltip]="dataItem.sale.status_reason" container="body">
          {{ dataItem.sale?.status_reason }}
        </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="sale.company.name"
      title="{{ 'CAMPAIGN.CAMPAIGN_LIST.COMPANY' | translate }}"
      filter="text"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <a
          [routerLink]="['/settings/companies/view']"
          [queryParams]="{ id: dataItem?.sale?.company_id }"
          target="_blank"
        >
          {{ dataItem?.sale?.company?.shortName }}
        </a>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="mail_send"
      headerClass="text-center"
      title="{{ 'CAMPAIGN.CAMPAIGN_LIST.MAIL_SEND' | translate }}"
      filter="boolean"
      [class]="'text-center'"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-active-indicator [active]="dataItem.mail_send"></app-active-indicator>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="sale.sales_agent.fake_first_name"
      title="{{ 'CAMPAIGN.CAMPAIGN_LIST.SALES_AGENT_AND_SALES_MANAGER' | translate }}"
      filter="text"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem?.sale?.sales_agent?.fake_first_name }} {{ dataItem?.sale?.sales_agent?.fake_last_name }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="sale.reservation_agent.fake_first_name"
      title="{{ 'CAMPAIGN.CAMPAIGN_LIST.RESERVATION_AGENT_AND_RESERVATION_MANAGER' | translate }}"
      filter="text"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem?.sale?.reservation_agent?.fake_first_name }} {{ dataItem?.sale?.reservation_agent?.fake_last_name }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="sale.customer_care_agent.fake_first_name"
      title="{{ 'CAMPAIGN.CAMPAIGN_LIST.CUSTOMER_CARE_AGENT' | translate }}"
      filter="text"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem?.sale?.customer_care_agent?.fake_first_name }}
        {{ dataItem?.sale?.customer_care_agent?.fake_last_name }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      *ngIf="accessService.hasAccess([UserRoleType.EXTERNAL_PARTNER_LEAD], [], true)"
      field="sale.total_amount"
      title="{{ 'CAMPAIGN.CAMPAIGN_LIST.TOTAL_AMOUNT' | translate }}"
      filter="numeric"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.sale.total_amount | number : '1.2-2' }} {{ 'DEFAULT_CURRENCY' | translate }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      *ngIf="accessService.hasAccess([UserRoleType.EXTERNAL_PARTNER_LEAD], [], true)"
      [width]="90"
      field="sale.rooms_count"
      title="{{ 'CAMPAIGN.CAMPAIGN_LIST.REQUESTED_ROOMS_COUNT' | translate }}"
      filter="numeric"
      format="0"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <div class="count-column-inner-custom">
          <span>
            <small>{{ 'SALES.SALES_LIST.ALL' | translate }}</small>
          </span>
          {{ dataItem.sale?.rooms_count }}
        </div>
        <div class="count-column-inner-custom center border-left">
          <span>
            <small>{{ 'SALES.SALES_LIST.CLOSED' | translate }}</small>
          </span>
          {{ dataItem.sale?.requestsClosedRoomsCount }}
        </div>
        <div class="count-column-inner-custom border-left">
          <span>
            <small>{{ 'SALES.SALES_LIST.REST' | translate }}</small>
          </span>
          {{ dataItem.sale?.rooms_count - dataItem.sale?.requestsClosedRoomsCount }}
        </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      class="text-center"
      headerClass="text-center"
      field="sale.requests.status.value"
      title="{{ 'CAMPAIGN.CAMPAIGN_LIST.CLIENT_REQUESTS_STATUS' | translate }}"
      width="150"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-type-badge
          *ngFor="let status of dataItem?.sale?.requestsUniqueStatuses; let i = index"
          [type]="status"
          class="d-block"
        ></app-type-badge>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="sale.assign_to_user.fake_first_name"
      title="{{ 'CAMPAIGN.CAMPAIGN_LIST.ASSIGNED_TO' | translate }}"
      filter="text"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem?.sale?.assign_to_user?.fake_first_name }} {{ dataItem?.sale?.assign_to_user?.fake_last_name }}
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>
</div>
